import React from 'react';
import './footer.scss';

function AppFooter() {
    return (
        <div className='app-footer-wrapper align-center'>
            <p className='app-footer-para'>© Hila Itzhak All rights reserved.</p>
        </div>
    );
}

export default AppFooter;
